import styled from 'styled-components';

const H3 = styled.h3.attrs({
  className: `
    text-lg
    font-semibold
    text-center
    text-gray-600
    
    dark:text-gray-300
  `,
})``;

export default H3;
